export const en = {
    translation: {
        or: "or",
        reset: "Reset",
        save: "Save",
        search: "Search",
        edit: "Edit",
        new: "New",
        export: "Export to Excel",
        noDataToExport: "No data to export",
        import: "Import",
        discard: "Discard",
        yes: "Yes",
        no: "No",
        pause: "Pause",
        areYouSure: "Are you sure?",
        view: "View",
        destroy: "Delete",
        mustSelectARow: "Must select a row",
        start: "Start",
        end: "End",
        select: "Select",
        continue: "Continue",
        filters: "Filters",
        status: "Status",
        description: "Description",
        unit: "Unit",
        ok: "Ok",
        close: "Close",
        confirm: "Confirm",
        noDataView: "No Data",
        passed: "Passed",
        failed: "Failed",
        msgSuccess: "Success",
        msgWarning: "Warning",
        msgError: "Error",
        msgInfo: "Information",
        msgConfirm: "Confirm",
        msgHint: "Hint",
        cancel: "Cancel",
        add: "Add",
        clear: "Clear",
        back: "Back",
        approve: "Approve",
        reject: "Reject",
        submit: "Submit",
        download: "Download",
        create: "Create",
        msgDuplicate: "Duplicate",
        msgSaveComplete: "Data has been saved.",
        msgDeleteComplete: "Data has been deleted.",
        msgConfirmSave: "Do you want to save the information ?",
        msgConfirmSaveDraft: "Do you want to save draft data ?",
        msgConfirmDelete: "Do you want to delete the data ?",
        msgConfirmApprove: "Do you want to approve data?",
        msgConfirmRevisit: "Do you want to revisit data?",
        msgConfirmCancel: "Do you want to cancel data?",
        msgConfirmReject: "Do you want to reject data?",
        msgNoPermission: "You do not have access to this page.",
        msgSessionTimeOut: "Please log in again.",
        msgDeleteFail: "Please select <i class='far fa-check-square'></i>",
        msgUploadImage: "Please upload image",
        msgConfirmLogout: "You want to log out ?",
        msgConfirmImport: "You want to upload data ?",
        msgConfirmChange: "You need to change information ?",
        pleaseSpecify: "Please specify",
        noInformationFound: "No Information Found",
        enterToSearch: "Enter To Search",
        searching: "Searching",
        selectAll: "Select All",
        all: "Total",
        msgSynchronize : "Do you want to Synchronize data",
        msgImportComplete: "Data has been Imported.",
        History:"History",
        Recalculate:"Recalculate",
        msgConfirmRequestEdit: "Do you want to request edit data ?",
    }
}